<div class="v4-layout-drawer-container flex flex-col">
  <!-- <div class="header">
    <div class="left-header">
      {{ getType(detail?.type) }}{{ "task.word.task" | translate }}
      {{ detail?.expected_date | dateformat: ["MD"] }}
    </div>
  </div> -->
  <div class="v4-layout-drawer-container-body overflow-y-auto">
    <div class="py-6" *ngIf="(houseId || staffId) && listOfTask.length > 1">
      <host-vertical-task-calendar
        [selectedTask]="taskId"
        [listOfTask]="listOfTask"
        (onClickTask)="onClickTask($event)"></host-vertical-task-calendar>
    </div>
    <div class="pt-6">
      <div class="v4-layout-info">
        <div class="v4-layout-info-title">
          <!-- 基础信息 -->
          {{ "task.detail.basic_info" | translate }}
        </div>
        <div class="v4-layout-field">
          <div class="v4-layout-field-label">
            <!-- 被分配人： -->
            {{ "task.word.assignee_1" | translate }}
          </div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              {{ detail?.staff?.name || ("task.detail.sidebar.staff.unassigned" | translate) }}
            </div>
          </div>
        </div>
        <div class="v4-layout-field">
          <div class="v4-layout-field-label">
            <!-- 时间： -->
            {{ "task.word.time_1" | translate }}
          </div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-control">
              {{ detail?.expected_format?.standard }}
            </div>
          </div>
        </div>
        <div class="v4-layout-field" *ngIf="detail?.house">
          <div class="v4-layout-field-label">
            <!-- 房间： -->
            {{ "task.word.property_1" | translate }}
          </div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              {{ detail?.house?.title_alias }}
            </div>
          </div>
        </div>
        <div class="v4-layout-field">
          <span class="v4-layout-field-label">
            <!-- 费用： -->
            {{ "task.word.fee_1" | translate }}
          </span>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <span>{{ detail?.currency_type | currencyToSymbol }}</span>
              <span>{{ detail?.fee }}</span>
              <span class="ml-2">{{ getLevel(detail?.level) }}</span>
            </div>
          </div>
        </div>
        <div class="v4-layout-field" *ngIf="detail?.note">
          <div class="v4-layout-field-label">
            <!-- 任务描述：  -->
            {{ "task.create.task_desc" | translate }}
          </div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              {{ detail?.note }}
            </div>
          </div>
        </div>
        <div class="v4-layout-field" *ngIf="detail?.next_booking">
          <div class="v4-layout-field-label">{{ "task.word.next_booking" | translate }}:</div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <span>{{ detail?.next_booking?.check_in | dateformat: ["MD"] }}</span>
              <span class="ml-2">
                {{
                  (detail?.next_booking?.number_of_guests > 1 ? "task.word.guest.plural" : "task.word.guest.singular")
                    | translate
                      : {
                          number: detail?.next_booking?.number_of_guests
                        }
                }}
              </span>
              <span
                class="ml-2 v4-tag inline-block !text-primary bg-[#e9f3ff]"
                *ngIf="detail?.next_booking?.back_to_back">
                {{ "task.word.back_to_back" | translate }}
              </span>
            </div>
          </div>
        </div>
        <div class="v4-layout-field" *ngIf="detail?.feedback">
          <div class="v4-layout-field-label">
            <!-- 任务反馈： -->
            {{ "task.create.task_feedback" | translate }}
          </div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              {{ detail?.feedback }}
            </div>
          </div>
        </div>
      </div>

      @if (detail?.check_list?.length) {
        <div class="v4-layout-info">
          <div class="v4-layout-info-title">
            {{ "task.word.check_list" | translate }}
          </div>
          <div>
            @for (item of detail.check_list; track item.id; let index = $index) {
              <div class="mb-[12px]">
                <label nz-checkbox [(ngModel)]="item.status" (ngModelChange)="onCheckListChange(item.id, $event)">{{
                  item.title
                }}</label>
              </div>
            }
          </div>
        </div>
      }

      <div class="v4-layout-info" *ngIf="detail?.photos.length > 0">
        <div class="v4-layout-info-title">
          <!-- 附件 -->
          {{ "task.word.attachment" | translate }}
        </div>
        <div class="v4-layout-field">
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <div class="mr-[10px] cursor-pointer" *ngFor="let img of detail?.photos">
                <img [hostImgPreview]="img?.large_url" [src]="img?.small_url" class="w-16 h-16" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="v4-layout-info" *ngIf="isDeleteable">
        <div class="v4-layout-field">
          <div class="v4-layout-field-control">
            <a nz-button nzType="link" nzDanger (click)="onDeleteTask()">{{ "task.detail.delete_task" | translate }}</a>
          </div>
        </div>
        <!-- <p class="delete" (click)="deleteTask()">
          删除任务
          {{ "task.detail.delete_task" | translate }}
        </p> -->
      </div>
    </div>
    <div class="bg-[#f6f6f6] px-6 py-3 rounded-[10px]" *ngIf="logList.length">
      <div *ngFor="let log of logList">
        <span class="text-s"> {{ log?.data }} </span>
        <span class="text-xs text-c-l1">{{ log?.action_time | dateformat }}</span>
      </div>
    </div>
  </div>

  <div class="v4-layout-drawer-container-footer flex flex-row items-center border-t border-solid border-c-gs">
    <div class="mr-3">
      <button nz-button nzSize="large" (click)="createTask()">
        <!-- 新建任务 -->
        {{ "calendar.pop.new_task" | translate }}
      </button>
    </div>

    <div class="w-24 mr-3">
      <host-select
        size="large"
        [showArrow]="true"
        [listOfOption]="[
          { label: 'task.list.pending' | translate, value: 0 },
          { label: 'task.list.ongoing' | translate, value: 1 },
          { label: 'task.list.completed' | translate, value: 2 }
        ]"
        [(value)]="status"
        (valueChange)="onSelectStatus($event)"></host-select>
    </div>

    <div class="mr-3">
      <button nz-button nzSize="large" (click)="close()">
        {{ "word.close" | translate }}
      </button>
    </div>

    <div class="mr-3">
      <button nz-button nzSize="large" (click)="modify()">
        {{ "word.modify" | translate }}
      </button>
    </div>
  </div>
</div>
